<parkour-page-image
  [src]="profiel | profielFoto: 'full' | async"
  classes="absolute top-0 left-0 z-0"
/>

<div class="relative z-10 py-8 container container-space">
  <ng-content select="[warningContent]" />
  <div class="flex flex-col items-center gap-4 container-1-col">
    <parkour-profiel-foto [profiel]="profiel" [size]="'10'" />

    <h1>{{ profiel | profielnaam }}</h1>

    <ng-content select="[typeContent]" />
    <parkour-divider />
  </div>

  <div class="flex flex-col gap-y-2 mt-8 container-1-col">
    <ng-content select="[topCardContent]" />

    <parkour-profiel-details-card
      icon="people-3"
      backgroundColor="bg-n-200"
      [title]="'profiel.title' | translate"
    >
      <div class="divide-y-[1.5px] divide-n-300">
        @if (profiel.bio || profiel.links.length > 0) {
          <div class="pb-4 flex flex-col gap-y-4">
            @if (profiel.bio) {
              <p data-testid="bio" class="whitespace-pre-wrap">{{ profiel.bio }}</p>
            }

            <ul>
              @for (link of profiel.links; track $index) {
                <li>
                  <parkour-button
                    classes="!text-left truncate"
                    [href]="link | httpLink"
                    iconBefore="link"
                    variant="ghost-light"
                    data-testid="link"
                  >
                    {{ getVisualLink(link) }}
                  </parkour-button>
                </li>
              }
            </ul>
          </div>
        }

        @if (profiel.voornaam || profiel.adres) {
          <ul
            [ngClass]="{
              'pt-4': profiel.bio || profiel.links.length > 0,
            }"
            class="space-y-4"
          >
            @if (profiel.voornaam) {
              <li>
                <parkour-profile-details-list-item
                  [detail]="profiel.voornaam + ' ' + profiel.naam"
                  [label]="'profiel.volledige-naam' | translate"
                  data-testid="volledige-naam"
                />
              </li>
            }

            @if (profiel.adres) {
              <li>
                <parkour-profile-details-list-item
                  [detail]="profiel.adres"
                  [label]="'profiel.contactadres' | translate"
                  data-testid="contact-adres"
                />
              </li>
            }
          </ul>
        }
      </div>
    </parkour-profiel-details-card>

    <ng-content select="[bottomCardContent]" />
  </div>
</div>
